export default __webpack_public_path__ + "static/media/question.298dfc7f.svg";